import { createSlice } from '@reduxjs/toolkit';
import { getTenantCourseDetail } from './tenantCourseDetailAction';

export const tenantCourseDetailSlice = createSlice({
  name: 'tenantCourseDetail',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTenantCourseDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTenantCourseDetail.fulfilled, (state, { payload }) => {      
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getTenantCourseDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
